import { render } from "./proxy-router.vue?vue&type=template&id=4d04bd34"
import script from "./proxy-router.vue?vue&type=script&lang=js"
export * from "./proxy-router.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__